export const payrocCss = {
    body: {
        margin: '0',
    },
    form: {
        display: 'flex',
        'align-items': 'center',
    },
    input: {
        'line-height': '2',
        'box-sizing': 'border-box',
        border: '1px solid #ced4da',
        'font-size': '1rem',
        width: '100%',
        height: '100%',
        padding: '8px',
        'border-radius': '5px',
        'background-color': '#FFF',
        color: 'rgb(99, 99, 99)',
        'text-align': 'left',
    },
    label: {
        padding: '8px 0',
        'font-family': 'Arial',
        'font-size': '0.8rem',
        display: 'inline-block',
    },
    ':focus': {
        outline: 'none',
    },
    '::placeholder': {
        color: 'rgb(158, 158, 158)',
        'font-style': 'italic',
    },
    "input[type='text']": {
        'min-height': '45px',
    },
    '::before': {
        content: '',
        width: '1rem',
        height: '1rem',
        'flex-basis': '1',
        'border-radius': '50%',
        transform: 'scale(0)',
        'transform-origin': 'center center',
        transition: '60ms transform ease-in-out',
        'box-shadow': 'inset 1rem 1rem rgb(23, 134, 97)',
    },
    ':checked::before': {
        transform: 'scale(1)',
        'transform-origin': 'center center',
        width: '23px',
        color: 'red',
        outline: '1px black solid',
        'line-height': '2',
    },
    button: {
        'background-color': '#13c513',
        color: '#FFF',
        border: '1px #13c513 solid',
        'border-radius': '8px',
        width: '500px',
        'text-align': 'center',
        'min-height': '45px',
        padding: '8px',
    },
    div: {
        margin: '0',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'margin-left': '8px',
    },
    'input[type="radio"]': {
        'line-height': 'unset',
        'box-sizing': 'content-box',
        appearance: 'none',
        'background-color': '#fff',
        margin: '0',
        'border-radius': '50%',
        width: '1.5rem',
        height: '1.5rem',
        'border-color': 'rgb(158, 158, 158)',
        color: 'rgb(23, 134, 97)',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'flex-direction': 'column',
        padding: 'unset',
        'min-height': 'unset',
        'margin-right': '5px',
    },
    'input[type="radio"]::before': {
        content: "'.'",
        width: '1rem',
        height: '1rem',
        'flex-basis': '1',
        'border-radius': '50%',
        transform: 'scale(0)',
        'transform-origin': 'center center',
        transition: '60ms transform ease-in-out',
        'box-shadow': 'inset 1rem 1rem rgb(23, 134, 97)',
    },
    'input[type="radio"]:checked::before': {
        transform: 'scale(1)',
        'transform-origin': 'center center',
    },
    'input.invalid': {
        color: '#d72d2d',
        'border-color': '#d72d2d',
    },
    '.loading-svg': {
        display: 'none',
        color: 'rgb(255, 255, 255)',
    },
    '.button-text': {
        display: 'inline-block',
        'font-size': '1rem',
        'font-weight': 'bold',
    },
    '.loading .loading-svg': {
        display: 'inline-block',
    },
    '.loading .button-text': {
        display: 'none',
    },
    '.spin': {
        animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
        to: {
            transform: 'rotate(1turn)',
        },
    },
    'button:hover': {
        cursor: 'pointer',
    },
};
